import { Base } from '@studiometa/js-toolkit';

/**
 * Component component.
 * @extends {Base}
 */
export default class Card extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Card',
    emits: ['open-modal'],
    options: {
      picture: String,
      display: String,
    },
  };

  /**
   *
   */
  onClick() {
    this.$emit('open-modal', this.$options.picture, this.$options.display);
  }
}
